import OnboardingService from '@/services/OnboardingService.js';
export const namespaced = true;
export const state = {
    isSavingPositions: false,
    isFetchingIcons: false,
    icons: [],
    commonGuestRuleIcons: []
};
export const mutations = {
    SET_IS_SAVING_POSITIONS(state, val) {
        state.isSavingPositions = val;
    },
    SET_IS_FETCHING_ICONS(state, val) {
        state.isFetchingIcons = val;
    },
    SET_ICONS(state, val) {
        state.icons = val;
    },
    SET_COMMON_GUEST_RULE_ICONS(state, val) {
        state.commonGuestRuleIcons = val;
    }
};
export const actions = {
    savePositions({ commit }, { positions }) {
        commit('SET_IS_SAVING_POSITIONS', true);
        return OnboardingService.savePositions(positions)
            .then(({ data }) => {
            window.enrich.enrichPosition(data.data.positions);
            commit('position/SET_POSITIONS', data.data.positions, { root: true });
        })
            .finally(() => {
            commit('SET_IS_SAVING_POSITIONS', false);
        });
    },
    fetchIcons({ state, commit }) {
        if (state.isFetchingIcons || state.icons.length > 0) {
            return false; // Hämtar bara en gång
        }
        commit('SET_IS_FETCHING_ICONS', true);
        return OnboardingService.getIcons()
            .then(({ data }) => {
            commit('SET_ICONS', data.data.all_icons);
            commit('SET_COMMON_GUEST_RULE_ICONS', data.data.common_guest_rule_icons);
        })
            .finally(() => {
            commit('SET_IS_FETCHING_ICONS', false);
        });
    }
};
export const getters = {};
